import React, { useState } from 'react';
import { EmailAccount } from '../useData';
import ShareAccountModal from './ShareAccountModal';

interface ShareAccountButtonProps {
  account: EmailAccount;
  onShared?: () => void;
  /** Show "Share" text next to icon (e.g. on detail page) */
  showLabel?: boolean;
  /** Compact icon-only styling for list cards */
  iconOnly?: boolean;
}

const ShareAccountButton: React.FC<ShareAccountButtonProps> = ({ account, onShared, showLabel, iconOnly }) => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          setModalOpen(true);
        }}
        className={
          iconOnly
            ? 'inline-flex h-9 w-9 items-center justify-center rounded-lg transition-colors text-emerald-600 hover:bg-emerald-50 hover:text-emerald-700 dark:text-emerald-400 dark:hover:bg-emerald-950/30'
            : 'inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-colors text-emerald-600 hover:text-emerald-700 hover:bg-emerald-50 dark:text-emerald-400 dark:hover:bg-emerald-900/20'
        }
        title="Share account"
      >
        <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
        </svg>
        {showLabel && <span>Share</span>}
      </button>
      <ShareAccountModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        accountId={account.id}
        accountName={account.emailAddress || account.displayName || 'Email account'}
        defaultShowInAccountsSidebar={account.showInAccountsSidebar ?? true}
        onShared={() => {
          onShared?.();
          setModalOpen(false);
        }}
        onSharesChanged={onShared}
      />
    </>
  );
};

export default ShareAccountButton;
